<template>
  <div class="">
    <h2 class="text-primary text-center fw-bolder my-3">Sign Up</h2>
    <form action=""
          class="row justify-content-center"
          @submit.prevent="signUp">
      <div class="col-md-10 col-12">
        <p class="text-danger fw-bold mb-1 text-center" v-if="errorMessage">{{ errorMessage }}</p>
        <div class="mb-3">
          <label for="name" class="form-label">Enter Name</label>
          <input type="text" class="form-control" v-model="inputName"
                 id="name" placeholder="UserName">
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Email Address</label>
          <input type="email" class="form-control" v-model="inputEmail"
                 id="email" placeholder="@gmail.com">
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input type="password" class="form-control" v-model="inputPassword"
                 id="password" placeholder="********">
        </div>
        <button class="btn btn-outline-primary float-end mb-3">Create Account</button>
      </div>
    </form>
  </div>
</template>

<script>
import {ref} from "vue";
import {auth} from "@/firebase/config";
import useSignUp from "@/composables/useSignUp";

export default {
  name: "SignUp",
  setup(props, context){
    let inputName = ref("");
    let inputEmail = ref("");
    let inputPassword = ref("");

    let {errorMessage, createAccount} = useSignUp();
    let signUp = async ()=>{
      let res = await createAccount(inputEmail.value, inputPassword.value, inputName.value)
      if (res){
        console.log(res.user);
        context.emit("goToChatRoom");
      }else {
        console.log(errorMessage.value);
      }
    }

    return{ inputName, inputEmail, inputPassword, signUp, errorMessage };
  }
}
</script>

<style scoped>

</style>